/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-24, 11:29:27
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-06, 15:22:49
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import { mapGetters, mapActions } from 'vuex';
import DownloadInvoice from '@/components/Common/DownloadInvoice';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'MyInvoicesCard',

  components: { DownloadInvoice },

  props: {
    lastInvoice: {
      type: Object,
      default() {
        return {
          amount: 0,
          posting_date: null,
          description: null,
        };
      },
    },
    acl: Object,
  },

  data() {
    return {
      icons: {
        invoice: require("@/assets/invoice.svg"),
        download: require("@/assets/download.svg"),
      }
    }
  },

  computed: {
    ...mapGetters(['pendingStoreActions']),
    isLoading() {
      return this.pendingStoreActions.includes('getCustomerInvoicesData');
    },
    canDownload() {
      return this.lastInvoice.description !== null;
    },
    year() {
      return this.canDownload && this.lastInvoice.description.split('/')[2];
    },
    month() {
      return this.canDownload && this.lastInvoice.description.split('/')[1];
    },
  },

  methods: {
    ...mapActions(['downloadInvoiceFile']),
    downloadFile() {
      const params = {
        year: this.year,
        month: this.month,
      };
      this.downloadInvoiceFile(params);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/MyAccount/MyInvoicesCard/component.js